import { render } from "./CompanyCard.vue?vue&type=template&id=73d96b3a"
import script from "./CompanyCard.vue?vue&type=script&lang=js"
export * from "./CompanyCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__